import { render, staticRenderFns } from "./Atos2.vue?vue&type=template&id=ce054ba2&scoped=true"
import script from "./Atos2.vue?vue&type=script&lang=js"
export * from "./Atos2.vue?vue&type=script&lang=js"
import style0 from "./Atos2.vue?vue&type=style&index=0&id=ce054ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce054ba2",
  null
  
)

export default component.exports